module.exports = __webpack_public_path__ + "c6b234719965cc10df0f8d12c1f438dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/clippy.svg
// module id = 160
// module chunks = 0 1